// import React from 'react';
// import { Container } from '@fast-ai/ui-components';

const Content = ({ children }) => children;

export default Content;
